module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_40ft_mob-8baa2949cda5707c7d6f113564a6f5b7.png";